import { TReduxActions } from '../../types/redux';
import { IFiltersState } from '../../types/filters';
import { FILTERS_SET_DEAL_TYPE_TYPE } from '../../constants/action_types';
import { JsonQuery } from '../../utils/jsonQuery';
import { defaultState } from './defaultState';

export function setDealTypeReducer(state: IFiltersState = defaultState, action: TReduxActions): IFiltersState {
  switch (action.type) {
    case FILTERS_SET_DEAL_TYPE_TYPE:
      return {
        ...state,
        jsonQuery: new JsonQuery(state.jsonQuery)
          .setDealType(action.dealType)
          .getSerializable(),
      };
  }

  return state;
}
